import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { httpClient } from "appUtility/Api";
import qs from "qs";
import ReactPlayer from 'react-player';
import ContainerHeader from 'components/ContainerHeader/index';
import IntlMessages from 'util/IntlMessages';
class TrainingVideos extends Component {
  constructor(props) {
    super(props);
    const login = localStorage.getItem("login");
    const loginData = login ? JSON.parse(login) : {};
    
    this.state = {
      categories: [],
      currentCategory: null,
      videos: [],
      loading: true,
      aid: loginData && loginData.aid ? loginData.aid : 1,  // Default to 1 if not available
      cid: loginData && loginData.cid ? loginData.cid : 4   // Default to 4 if not available
    };
  }

  componentDidMount() {
    this.fetchCategories();
  }

  componentDidUpdate(prevProps) {
    const currentSlug = this.getLastUrlPart();
    const prevSlug = this.getLastUrlPart(prevProps.location.pathname);
    
    if (currentSlug !== prevSlug) {
      this.findCategoryAndLoadVideos();
    }
  }

  getLastUrlPart = (path) => {
    const pathToUse = path || (this.props.location && this.props.location.pathname);
    if (!pathToUse) return '';
    
    const parts = pathToUse.split('/');
    return parts[parts.length - 1];
  };

  fetchCategories = async () => {
    this.setState({ loading: true });
    
    try {
      const response = await httpClient.post(
        "v2/trainingCategories.php",
        qs.stringify({
          action: "getList",
          "source[appID]": this.state.aid,
          "source[companyID]": this.state.cid
        })
      );

      if (response && response.data && response.data.success && response.data.data) {
        this.setState({ 
          categories: response.data.data,
          loading: false 
        }, this.findCategoryAndLoadVideos);
      } else {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      this.setState({ loading: false });
    }
  };

  findCategoryAndLoadVideos = () => {
    const slug = this.getLastUrlPart();
    const { categories } = this.state;
    
    if (!categories || !categories.length) return;

    const matchedCategory = categories.find(cat => 
      cat && cat.slug && cat.slug.toLowerCase() === slug.toLowerCase()
    );

    if (matchedCategory) {
      this.setState({ currentCategory: matchedCategory }, this.fetchVideos);
    } else {
      this.setState({ loading: false });
    }
  };

  fetchVideos = async () => {
    const { currentCategory } = this.state;
    if (!currentCategory || !currentCategory.categoryID) {
      this.setState({ loading: false });
      return;
    }

    this.setState({ loading: true });

    try {
      const response = await httpClient.post(
        "v2/trainingItems.php",
        qs.stringify({
          action: "getList",
          "source[appID]": this.state.aid,
          "source[companyID]": this.state.cid,
          "source[categoryID]": currentCategory.categoryID
        })
      );

      if (response && response.data && response.data.success && response.data.data) {
        this.setState({ 
          videos: response.data.data,
          loading: false 
        });
      } else {
        this.setState({ videos: [], loading: false });
      }
    } catch (error) {
      console.error("Error fetching videos:", error);
      this.setState({ videos: [], loading: false });
    }
  };

  render() {
    const { videos, loading, currentCategory } = this.state;
    const slug = this.getLastUrlPart();

    return (
    


      <div className="animated slideInUpTiny animation-duration-3 jr-card ">
        {/* {currentCategory && currentCategory.categoryName && (
          	<ContainerHeader title={<IntlMessages id={currentCategory.categoryName}/>}/>
          // <h2>{currentCategory.categoryName}</h2>
        )} */}

        {loading ? (
          <div>Loading videos...</div>
        ) : videos && videos.length > 0 ? (
          <div className="row jr-card" >
            {videos.map(video => (
              <div 
                key={video && video.itemID ? video.itemID : Math.random()}
                className="col-4" style={{marginBottom:"1.3rem"}}
              >
                {video && video.title && <h3>{video.title}</h3>}
                {video && video.fileURL && (
                  <ReactPlayer
                    url={`${video.fileURL}?cache=false`}
                   width='420'
                  
                controls
                    light={video.thumbURL ? video.thumbURL : true}
                  />
                )}
                {/* {video && video.description && <p>{video.description}</p>} */}
              </div>
            ))}
          </div>
        ) : (
          <div>No videos found in this category</div>
        )}
      </div>
    );
  }
}

export default withRouter(TrainingVideos);